import {
  FETCH_REPORTS_SUMMARY_SUCCESS,
  FETCH_REPORTS_SALES,
  FETCH_REPORTS_SALES_SUCCESS,
  FETCH_REPORTS_SALES_FAILURE,
  FETCH_PAYOUTS,
  FETCH_PAYOUTS_SUCCESS,
  FETCH_PAYOUTS_FAILURE,
} from '../constants/ActionTypes';

const emptyTable = () => ({
  count: 0,
  pages: 0,
  current: null,
  results: null,
  isFetching: false,
});

export const initialState = {
  // money summary by role (`all` is both roles together), null until it is fetched
  summary: { author: null, affiliate: null, all: null },
  // one page of the sales table: one row per sale, whatever the role
  sales: emptyTable(),
  // one page of the payouts and the balance block of the answer
  payouts: { ...emptyTable(), balance: null },
};

const pagesOf = (count, pageSize) => Math.ceil(count / pageSize);

export default function reports(state = initialState, action) {
  switch (action.type) {
    case FETCH_REPORTS_SUMMARY_SUCCESS:
      return {
        ...state,
        summary: { ...state.summary, [action.role]: action.data },
      };

    case FETCH_REPORTS_SALES:
      return { ...state, sales: { ...state.sales, isFetching: true } };

    case FETCH_REPORTS_SALES_SUCCESS:
      return {
        ...state,
        sales: {
          count: action.data.count,
          pages: pagesOf(action.data.count, action.pageSize),
          current: action.page,
          results: action.data.results,
          isFetching: false,
        },
      };

    case FETCH_REPORTS_SALES_FAILURE:
      return { ...state, sales: { ...state.sales, isFetching: false } };

    case FETCH_PAYOUTS:
      return { ...state, payouts: { ...state.payouts, isFetching: true } };

    case FETCH_PAYOUTS_SUCCESS:
      return {
        ...state,
        payouts: {
          count: action.data.count,
          pages: pagesOf(action.data.count, action.pageSize),
          current: action.page,
          results: action.data.results,
          balance: action.data.balance,
          isFetching: false,
        },
      };

    case FETCH_PAYOUTS_FAILURE:
      return { ...state, payouts: { ...state.payouts, isFetching: false } };

    default:
      return state;
  }
}
